import { gql } from "@apollo/client";

export const VERIFY_USER_QUERY = gql`
  query VerifyUser($token: String) {
    verifyUser(token: $token) {
      _id
      id
      name
      email
      role
    }
  }
`;
export const USERS_QUERY = gql`
  query Users($searchParams: String) {
    users(searchParams: $searchParams) {
      users {
        _id
        id
        name
        email
        created_at
        updated_at
      }
      metaData {
        totalCount
        totalPages
      }
    }
  }
`;

export const USER_QUERY = gql`
  query User($id: String!) {
    user(id: $id) {
      _id
      id
      name
      email
      created_at
      updated_at
    }
  }
`;
